import { createSelector } from 'reselect';

const contactTypes = (state) => state.publisherContactTypes;
const timezonesList = (state) => state.publisherTimezonesList;

export const getContactTypes = createSelector(
    contactTypes,
    (contactTypes = []) => {
        return contactTypes.map((item) => {
                return {
                    value: item.name,
                    title: item.title,
                    disabled: item.supported
                };
            })
    }
);

export const getTimezonesList = createSelector(
    timezonesList,
    (timezonesList = []) => {
        return timezonesList.map((item) => {
                return {
                    value: item.name,
                    title: item.title
                };
            })
    }
);
